<template>
  <div class="content-wrapper">
    <div>
      <h2 class="text-center pt-5 pb-3">{{$route.query.name}}</h2>
      <div class="float-left">
        <h4 class="card-title">{{$route.query.category}}</h4>
        <h3 class="card-title">{{$route.query.group}}</h3>
      </div>
      <div class="float-right">
        <h4 v-show="$route.query.startDateFormatted != null" class="card-title">{{$t("Start Date")}}: <span class="float-right pl-2">{{ $route.query.startDateFormatted != null ? $route.query.startDateFormatted : ''}}</span></h4>
        <h4 v-show="$route.query.endDateFormatted != null" class="card-title">{{$t("End Date")}}: <span class="float-right pl-2">{{ $route.query.endDateFormatted != null ? $route.query.endDateFormatted : ''}}</span></h4>
        <!--<h4 v-show="reportDate != null && hideForForms === true" class="card-title"><span class="float-right pl-2">{{ reportDate}}</span></h4>-->
      </div>
      <br><br>
    </div>
    <b-table
      show-empty
      hover
      responsive
      :items="data"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
    >
      <template v-slot:empty="scope">
        <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
      </template>
      <template v-slot:cell(temperature)="row">
        <div>{{row.item.temperature}} ℃</div>
      </template>
      <!--<template v-slot:cell(timestamp)="row">-->

      <!--</template>-->

    </b-table>
  </div>

</template>

<script>
export default {
  name: 'PrintPage',
  data () {
    return {
      sortBy: '',
      fields: [],
      data: [],
      sortDesc: true,
      sortDirection: 'asc'
    }
  },
  mounted () {
    console.log(this.$route.query)
    var self = this
    this.$route.query.fields.forEach(data => {
      self.fields.push(JSON.parse(data))
    })
    console.log(this.fields)
    console.log(this.data)
    this.$route.query.data.forEach(data => {
      self.data.push(JSON.parse(data))
    })

    window.onafterprint = window.close
    print()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PrintPage.vue